import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Header, LoaderDots, NavHeader, Page, PopUpNav, SubmitButton } from '../../../../components';
import { IconPointer } from '../../../../assets/icons/icon-pointer';
import { IconDelete } from '../../../../assets/popup-nav-icons';
import { useInstallationContext } from '../../../../context/installation';
import { IntegrationType } from '../../../../data-access/gql-types/graphql';
import { useLocationCoords } from '../../hooks/use-location-coords';
import { LocationCoords } from '../../types';
import { LocationPermissionDialog } from '../location-permission-dialog';
import { useLocationContext } from '../location/context/location.context';
import MapComponent from '../map';
import RemoveLocation from '../remove-location';
import './index.scss';

type LocationMapProps = {
  handleLocationSet: (coords: LocationCoords) => void;
};

const LocationMap: React.FC<LocationMapProps> = ({ handleLocationSet }) => {
  const { t } = useTranslation('installation');
  const [loader, setLoader] = useState<boolean>(false);
  const [removePopup, setRemovePopup] = useState<boolean>(false);
  const { setCoords, coords, goBack, goHome } = useLocationContext();
  const { getCoords, permissionDialog, setPermissionDialog, getCoordsIfPermissionsAvailable } =
    useLocationCoords(setLoader);
  const { integrationType } = useInstallationContext();

  const saveLocation = () => {
    handleLocationSet({ latitude: coords.latitude, longitude: coords.longitude });
    goHome();
  };

  const removeLocation = () => {
    setCoords({ latitude: null, longitude: null });
    setRemovePopup(false);
    handleLocationSet({ latitude: null, longitude: null });
    goHome();
  };

  const showRemovePopup = (value: boolean) => setRemovePopup(value);

  return (
    <Page
      kind="above"
      className="location_map_page"
      header={
        <>
          <NavHeader onClick={goBack}>
            {integrationType !== IntegrationType.Exalus && (
              <PopUpNav
                dark
                links={[{ label: t('locationRemove'), onClick: () => showRemovePopup(true), icon: <IconDelete /> }]}
              />
            )}
          </NavHeader>
          <Header title={t('installationLocation')} />
        </>
      }
    >
      <MapComponent />
      <button className="my_location" onClick={getCoordsIfPermissionsAvailable} type="button">
        {loader ? <LoaderDots /> : <IconPointer />}
      </button>
      <div className="submit_location">
        <p className="address">{coords.latitude && coords.longitude && `${coords.latitude}, ${coords.longitude}`}</p>
        <SubmitButton type="button" onClick={saveLocation} />
      </div>
      <RemoveLocation show={removePopup} setShow={() => showRemovePopup(false)} onConfirm={removeLocation} />
      <LocationPermissionDialog show={permissionDialog} setShow={setPermissionDialog} handleAction={getCoords} />
    </Page>
  );
};

export default LocationMap;
